import React, { useState } from "react";
import { HiMenuAlt2 } from "react-icons/hi";

export const Header = () => {
  const [dropdown, setDropdown] = useState<boolean>(false);
  return (
    <div className="navbar min-h-0 h-[60px] flex items-center px-5 bg-slate-900 shadow-2xl shadow-gray-100">
      <div className="navbar-start">
        <h1 className="flex justify-center items-center mt-1">
          <img src="/logo.svg" alt="PromptMaker - create prompts infinitely -" className="h-8" />
        </h1>
      </div>
      <div className="navbar-end">
        <div className="dropdown dropdown-end">
          <button
            className="btn btn-ghost btn-circle !border-white btn-sm"
            onClick={() => {
              setDropdown(!dropdown);
            }}
          >
            <HiMenuAlt2 className="text-white" />
          </button>
          {dropdown && (
            <ul className="menu menu-compact dropdown-content mt-[6px] p-2 shadow bg-base-100 rounded-lg w-52 !visible !opacity-100">
              <li>
                <a
                  href="https://iktakagishi.notion.site/How-to-use-PromptMaker-c8192956cfea4879a5a2eb392e646802"
                  target="_blank"
                  rel="noreferrer"
                >
                  How to use
                </a>
              </li>
              <li>
                <a href="https://www.buymeacoffee.com/ik.takagishi" target="_blank" rel="noreferrer">
                  Buy me a coffee!
                </a>
              </li>
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};
